module.exports = {"id":"207624","name":"Kenneth Omeruo","rating":"73","photo":"./data/images/photos/0/207624.png","club":{"name":"Kasimpaşa","logo":"./data/images/clubs/Kasimpasa.png"},"positions":["DC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KennethOmeruo0.json
// module id = 2325
// module chunks = 0